<template>
  <!-- 学生学习报告 -->
  <div class="paginations">
    <div class="table-search-box table-search-box-haeder">
      <el-form :inline="true" :model="searchData" class="demo-form-inline" v-if="!isExhibition">
        <el-form-item label="学生姓名">
          <el-input size="small" v-model="searchData.userName" placeholder="学生姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="search_button">
            <i class="pointer el-icon-search" @click="search(searchData.userName)"></i>
            <i class="pointer el-icon-refresh-left" @click="(isExhibition = false), (searchData.userName = '')"></i>
          </div>
        </el-form-item>

        <!-- <el-form-item>
          <el-button type="primary" @click="batchExportHandler" class="exportButton">批量导出</el-button>
        </el-form-item> -->
      </el-form>
      <el-button class="recurrence" v-if="isExhibition" @click="(isExhibition = false), (searchData.userName = '')">返回</el-button>
    </div>

    <div class="table_box">
      <el-table :data="oneTableObj.list" ref="table" style="width: 100%" v-if="!isExhibition">
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column type="index" label="序号" width="120" align="center"> </el-table-column>
        <el-table-column prop="userName" label="学生姓名" align="center"> </el-table-column>
        <el-table-column prop="loginName" label="账号" align="center"></el-table-column>
        <el-table-column prop="institute" label="学校" align="center" width="250"></el-table-column>
        <el-table-column prop="userCode" label="学号" align="center"> </el-table-column>
        <el-table-column prop="sex" label="性别" align="center" width="50"> </el-table-column>
        <el-table-column prop="province" label="所属省份" align="center"> </el-table-column>
        <el-table-column prop="Datekey" label="数据分析截止时间" align="center"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <i class="icona icon-see" title="学生学习报告" @click="see(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="oneTableObj.total" :jumpTo="oneTableObj.jumpTo" @currentChange="getList"></pageNumber>
    </div>
  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue'; // 分页

export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      searchData: {
        userName: '',
        pageDto: {
          pageNum: 1, // 当前显示的页面页码数
          pageSize: 10, // 一页多少条数据
        },
      },
      DateStr: '',
      oneTableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      isExhibition: false, //是否显示二级表格
    };
  },
  created() {
    this.getList();

    this.zykId = sessionStorage.getItem('zykId')

    // 格式化时间日期
    let str = '-';
    let date = new Date();
    let Year = date.getFullYear();
    let Month = date.getMonth() + 1;
    let Day = date.getDate();
    if (Month >= 1 && Month <= 9) Month = "0" + Month;
    if (Day >= 1 && Day <= 9) Day = "0" + Day;
    let currentDate = Year + str + Month + str + Day;

    this.DateStr = currentDate;
  },
  methods: {
    // 获取一级表格数据
    getList(type) {
      this.searchData.pageDto.pageNum = type ? type : 1;
      this.oneTableObj.jumpTo = type ? type : 1;
      this.$axios
        .post(
          this.$apiurls.applicationReport_getList,
          {
            pageDto: this.searchData.pageDto,
            statType: 11,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.oneTableObj.list = res.data.list;
            let DateKey = "Datekey";
            let DateValue = this.DateStr;
            this.oneTableObj.list.forEach((item) => {
              item[DateKey] = DateValue;
            });
            this.oneTableObj.total = res.data.total;
          }
        });
    },
    // 查询获取二级表格数据
    search(name) {
      this.$axios
        .post(
          this.$apiurls.applicationReport_getZykUserInfoVoByRole,
          {
            role: 1,
            userName: name ? name : this.searchData.userName,
          },
          {
            loading: false,
          },
          { timeout: 3 * 60 * 1000 }
        )
        .then((res) => {
          if (res) {
            this.oneTableObj.list = res.data;
          }
        });
    },

    // batchExportHandler() {
    //   let select = this.$refs.table.selection

    //   let selectZykidArr = select.map(item => {
    //     let zykid = item.userId
    //     return zykid
    //   })

    //   let selectNameArr = select.map(item => {
    //     let userName = item.userName
    //     return userName
    //   })

    //   let userId = selectZykidArr.join(",");
    //   let selectName = selectNameArr.join(",")

    //   this.$axios.post(this.$apiurls.exportBatchReport, {
    //     zykid: this.zykId,
    //     type: 1,
    //     param: { userid: userId, username: selectName }
    //   }).then(res => {
    //     window.open(`${this.$apiurls.downloadReport}?file_path=${res.data}`)
    //   })
    // },


    // 查看
    see(row) {
      const news = this.$router.resolve({
        name: '/tInformation',
        query: { userId: encodeURIComponent(row.userId), userType: '学生' },
      });
      console.log(`${news.location.name}${news.href}`);
      window.open(`${news.location.name}${news.href}`, '_blank');
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped>
</style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped>
</style>
<style lang="scss" scoped>
.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.table-search-box-haeder {
  height: 40px;
  margin-bottom: 20px;
}
.recurrence {
  background: rgba(46, 62, 99, 0.79);
  color: #1bf6f8;
  border: 0px;
  font-size: 13px;
  padding: 9px 10px;
  margin-bottom: 10px;
}

.el-button--primary {
  background: rgba(46, 62, 99, 0.79);
  outline: none;
  border: 1px solid rgba(46, 62, 99, 0.79);
  // color: rgba(0, 255, 255, 1);
}

.exportButton {
  height: 33px;
  margin-top: 5px;
  line-height: 0px;
}
</style>
